import React, { useEffect } from 'react';
import Title from '../Components/Title';
import ContactItem from '../Components/ContactItem';
import ContactForm from '../Components/ContactForm';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { MainLayout, } from '../Styles/mainLayouts';
import styles from '../Styles/hoverText.module.css'
import styled from 'styled-components';
import AOS from 'aos';
import 'aos/dist/aos.css';


const ContactPageStyled = styled.section`
        padding: 5rem 0;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 2rem;
        @media screen and (max-width: 978px){
            grid-template-columns: repeat(1, 1fr);
            .f-button{
                margin-bottom: 3rem;
            }
        }
        @media screen and (max-width: 600px){
            overflow: hidden;
        }
        .right-content-contact{
            display: flex;
            gap: 1rem;
            flex-direction: column;
        }
        .left-content-contact{
            padding-bottom:1rem;
        }
`;

const ContactPage = () => {

    useEffect(() => {
        AOS.init({ duration: 2000, })
    }, [])

    return (
        <MainLayout>
            <Title title={'Contact'} />
            {/* <Title title={'Contact'} span={'Contact'} /> */}
            <ContactPageStyled>
                <div className="left-content-contact" data-aos="fade-right">
                    <ContactForm />
                </div>
                <div className="right-content-contact" data-aos="fade-left">
                    <ContactItem title={'Phone'} icon={
                        <p className={styles.tooltip}><a href="tel:+9140708447"><PhoneIcon /></a>
                            <span className={styles.tooltipText}>click to make call</span>
                        </p>} cont={'+919140708447'} />
                    <ContactItem title={'Email'} icon={
                        <p className={styles.tooltip} style={{ paddingBottom: "1px" }}><a href="https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox" target="_blank" rel="noopener noreferrer"><EmailIcon /></a>
                            <span className={styles.tooltipText}>click to send mail</span>
                        </p>} cont={'mohammadtausif14@gmail.com'} />
                    <ContactItem title={'Address'} icon={<LocationOnIcon />} cont={'Budaun, Uttar Pradesh'} />
                </div>
            </ContactPageStyled>
        </MainLayout>
    )
}

export default ContactPage
